export const Logo = ({ variant = "light", className = "" }) => {
    const src = variant === "dark" ? "/brand/logo-on-dark.png" : "/brand/logo-light.png";
    return (
        <img
            src={src}
            alt="Back At One"
            className={className}
            data-testid="brand-logo"
        />
    );
};
